// 本地演示拓扑：不依赖大模型与后端，打开 /#demo 即可在三维视图中检查各类节点模型。
import { withStyle } from './topology'

// 先把节点摊在球面上，保证不同类型的模型互不遮挡。
function place(index, total, radius = 300) {
  const y = 1 - 2 * (index + 0.5) / total
  const angle = index * Math.PI * (3 - Math.sqrt(5))
  const ring = Math.sqrt(1 - y * y)
  return {
    x: Math.cos(angle) * ring * radius,
    y: y * radius,
    z: Math.sin(angle) * ring * radius
  }
}

const rawNodes = [
  { id: 'N-CORE', label: '核心路由', category: 'router', modelId: 'router_rack', status: 'normal', meta: { 型号: 'CR-9000' } },
  { id: 'N-SW', label: '汇聚交换', category: 'switch', modelId: 'switch_uplink', status: 'normal', meta: { 端口数: 24, 交换容量: '48 Gbps' } },
  { id: 'N-GW', label: '安全网关', category: 'gateway', modelId: 'gateway_industrial', status: 'normal', meta: { 并发会话: 12000, 转发吞吐: '8 Gbps' } },
  { id: 'N-BS', label: '接入基站', category: 'station', modelId: 'station_tripod', status: 'normal', meta: { 频段: '5 GHz', 信道带宽: '80 MHz', 关联终端: 3 } },
  { id: 'N-SAT', label: '卫星中继', category: 'satellite', modelId: 'satellite_relay', status: 'normal', meta: { 轨道高度: '550 km', 转发方式: '星上再生' } },
  { id: 'N-UAV1', label: '侦察无人机', category: 'drone', modelId: 'drone_quad', status: 'normal', meta: { 巡航高度: '120 m', 电池电量: '78%' } },
  { id: 'N-UAV2', label: '中继无人机', category: 'drone', modelId: 'drone_fixed_wing', status: 'degraded', meta: { 巡航高度: '150 m', 电池电量: '31%', 链路质量: '一般' } },
  { id: 'N-SRV', label: '业务服务', category: 'service', modelId: 'service_micro', status: 'normal', meta: { 实例数: 3, 平均处理时延: '12 ms' } },
  { id: 'N-STO', label: '存储阵列', category: 'storage', modelId: 'storage_nas', status: 'normal', meta: { 容量: '48 TB', 已用空间: '63%' } },
  { id: 'N-CTL', label: '控制中心', category: 'controller', modelId: 'controller_handheld', status: 'normal', meta: { 控制周期: '100 ms', 控制协议: 'Modbus TCP' } },
  { id: 'N-SEN', label: '环境传感', category: 'sensor', modelId: 'sensor_lidar', status: 'degraded', meta: { 采样周期: '1 s', 上报间隔: '10 s' } },
  { id: 'N-ACT', label: '执行机构', category: 'actuator', modelId: 'actuator_pneumatic', status: 'saturated', meta: { 行程: '90°', 响应时间: '35 ms' } },
  { id: 'N-TER', label: '运维终端', category: 'terminal', modelId: 'terminal_rugged', status: 'down', meta: { 接入方式: 'IEEE 802.11ax' } }
]

const nodes = rawNodes.map((node, index) => ({ ...node, ...place(index, rawNodes.length) }))

const edges = [
  {
    source: 'N-CORE',
    target: 'N-SW',
    linkId: 'C0001',
    label: '10 Gbps',
    value: 10000,
    status: 'normal',
    linkType: 'wired',
    meta: { 传播时延: '1 ms' },
    sourceNic: { id: 'N-CORE:IF000001', status: 'normal', meta: { 发送速率: '9800 Mbps', 累计发送数据包: 8421, 队列容量: 666, 当前排队数据包: 12 } },
    targetNic: { id: 'N-SW:IF000001', status: 'normal', meta: { 接收速率: '9760 Mbps', 累计接收数据包: 8477 } }
  },
  {
    source: 'N-SW',
    target: 'N-GW',
    linkId: 'C0002',
    label: '1000 Mbps',
    value: 1000,
    status: 'normal',
    linkType: 'wired',
    meta: { 传播时延: '1 ms' },
    sourceNic: { id: 'N-SW:IF000002', status: 'normal', meta: { 发送速率: '880.5 Mbps', 累计发送数据包: 5127 } },
    targetNic: { id: 'N-GW:IF000001', status: 'normal', meta: { 接收速率: '874.2 Mbps', 累计接收数据包: 5093 } }
  },
  {
    source: 'N-GW',
    target: 'N-SRV',
    linkId: 'C0003',
    label: '1000 Mbps',
    value: 1000,
    status: 'degraded',
    linkType: 'wired',
    meta: { 传播时延: '2 ms', 丢包率: '1.4%' },
    sourceNic: { id: 'N-GW:IF000002', status: 'degraded', meta: { 发送速率: '420.8 Mbps', 累计发送数据包: 3110 } },
    targetNic: { id: 'N-SRV:IF000001', status: 'degraded', meta: { 接收速率: '398.1 Mbps', 累计接收数据包: 2688 } }
  },
  {
    source: 'N-SRV',
    target: 'N-STO',
    linkId: 'C0004',
    label: '10 Gbps',
    value: 10000,
    status: 'normal',
    linkType: 'wired',
    meta: { 传播时延: '0.5 ms' },
    sourceNic: { id: 'N-SRV:IF000002', status: 'normal', meta: { 发送速率: '2400 Mbps', 累计发送数据包: 1265 } },
    targetNic: { id: 'N-STO:IF000001', status: 'normal', meta: { 接收速率: '2388 Mbps', 累计接收数据包: 1261 } }
  },
  {
    source: 'N-SW',
    target: 'N-BS',
    linkId: 'C0005',
    label: '1000 Mbps',
    value: 1000,
    status: 'saturated',
    linkType: 'wired',
    meta: { 传播时延: '1 ms', 丢包率: '2.1%' },
    sourceNic: {
      id: 'N-SW:IF000005',
      status: 'saturated',
      meta: { 发送速率: '298.7 Mbps', 累计发送数据包: 6448, 队列容量: 666, 当前排队数据包: 665 }
    },
    targetNic: { id: 'N-BS:IF000001', status: 'normal', meta: { 接收速率: '292.4 Mbps', 累计接收数据包: 6301 } }
  },
  {
    source: 'N-BS',
    target: 'N-TER',
    linkId: 'WC0001',
    label: '无线接入',
    value: 300,
    status: 'down',
    linkType: 'wireless',
    meta: { 信道带宽: '80 MHz', 无线协议: 'IEEE 802.11ax' },
    sourceNic: { id: 'N-BS:WIF000002', status: 'down', meta: { 发射功率: '20 dBm', 频段: '5 GHz' } },
    targetNic: { id: 'N-TER:WIF000001', status: 'down', meta: { 信号强度: '-88 dBm', 信噪比: '6 dB', 可用传输速率: '0 Mbps' } }
  },
  {
    source: 'N-BS',
    target: 'N-UAV1',
    linkId: 'WC0002',
    label: '无线链路',
    value: 240,
    status: 'normal',
    linkType: 'wireless',
    meta: { 信道带宽: '80 MHz', 无线协议: 'IEEE 802.11ax' },
    sourceNic: { id: 'N-BS:WIF000003', status: 'normal', meta: { 发射功率: '20 dBm', 关联终端数: 3 } },
    targetNic: { id: 'N-UAV1:WIF000001', status: 'normal', meta: { 信号强度: '-52 dBm', 信噪比: '31 dB', 可用传输速率: '240 Mbps' } }
  },
  {
    source: 'N-BS',
    target: 'N-UAV2',
    linkId: 'WC0003',
    label: '无线链路',
    value: 48,
    status: 'degraded',
    linkType: 'wireless',
    meta: { 信道带宽: '80 MHz', 无线协议: 'IEEE 802.11ax' },
    sourceNic: { id: 'N-BS:WIF000004', status: 'degraded', meta: { 发射功率: '20 dBm', 关联终端数: 3 } },
    targetNic: { id: 'N-UAV2:WIF000001', status: 'degraded', meta: { 信号强度: '-76 dBm', 信噪比: '12 dB', 可用传输速率: '48 Mbps' } }
  },
  {
    source: 'N-UAV1',
    target: 'N-SAT',
    linkId: 'WC0004',
    label: '星地链路',
    value: 120,
    status: 'normal',
    linkType: 'wireless',
    meta: { 频段: 'Ku 波段', 传播时延: '18 ms' },
    sourceNic: { id: 'N-UAV1:WIF000002', status: 'normal', meta: { 发射功率: '24 dBm' } },
    targetNic: { id: 'N-SAT:WIF000001', status: 'normal', meta: { 信号强度: '-64 dBm', 可用传输速率: '120 Mbps' } }
  },
  {
    source: 'N-BS',
    target: 'N-SEN',
    linkId: 'WC0005',
    label: '传感接入',
    value: 20,
    status: 'normal',
    linkType: 'wireless',
    meta: { 信道带宽: '20 MHz', 无线协议: 'IEEE 802.11n' },
    sourceNic: { id: 'N-BS:WIF000005', status: 'normal', meta: { 关联终端数: 3 } },
    targetNic: { id: 'N-SEN:WIF000001', status: 'normal', meta: { 信号强度: '-58 dBm', 可用传输速率: '20 Mbps' } }
  },
  {
    source: 'N-SEN',
    target: 'N-ACT',
    linkId: 'C0006',
    label: '50 Mbps',
    value: 50,
    status: 'normal',
    linkType: 'wired',
    meta: { 传播时延: '0.5 ms' },
    sourceNic: { id: 'N-SEN:IF000001', status: 'normal', meta: { 发送速率: '12.4 Mbps', 累计发送数据包: 1836 } },
    targetNic: { id: 'N-ACT:IF000001', status: 'normal', meta: { 接收速率: '12.4 Mbps', 累计接收数据包: 1836 } }
  },
  {
    source: 'N-CTL',
    target: 'N-ACT',
    linkId: 'C0007',
    label: '100 Mbps',
    value: 100,
    status: 'normal',
    linkType: 'wired',
    meta: { 传播时延: '0.4 ms' },
    sourceNic: { id: 'N-CTL:IF000001', status: 'normal', meta: { 发送速率: '3.2 Mbps', 累计发送数据包: 642 } },
    targetNic: { id: 'N-ACT:IF000002', status: 'normal', meta: { 接收速率: '3.2 Mbps', 累计接收数据包: 640 } }
  },
  {
    source: 'N-CTL',
    target: 'N-CORE',
    linkId: 'C0008',
    label: '1000 Mbps',
    value: 1000,
    status: 'normal',
    linkType: 'wired',
    meta: { 传播时延: '1 ms' },
    sourceNic: { id: 'N-CTL:IF000002', status: 'normal', meta: { 发送速率: '88.6 Mbps', 累计发送数据包: 2740 } },
    targetNic: { id: 'N-CORE:IF000002', status: 'normal', meta: { 接收速率: '88.1 Mbps', 累计接收数据包: 2735 } }
  }
]

export const DEMO_TOPOLOGY = { nodes: withStyle(nodes), edges }
